export default function() {
  return {
    measures: [],
    landApplications: [],
    shaftApplications: []
  }
}
